<!--
 Menu includes only two points: "Edit" and "Delete" for now.
 This is reason why an action button is hidden completely when user doesn't have permissions to edit/delete a notification.
 If the menu includes additional items then a visibility logic should be considered again
-->
@if (isUpdateDeleteAllowed) {
  <osp-button
    [category]="'ghost'"
    [rounded]="true"
    [icon]="IconKey.GlobalActions | icon"
    (onClick)="toggleMenu($event)"
  />
  <osp-menu #actionsMenu [model]="options" [popup]="true" />
}
